import styled from 'theme';

export const Page = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
`;
